import { render, staticRenderFns } from "./Linear.vue?vue&type=template&id=1ecfa621"
import script from "./Linear.vue?vue&type=script&lang=js"
export * from "./Linear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports